// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.Login.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
// $FlowFixMe
import isNil from 'lodash/fp/isNil';

import AccountConstants from 'logic/data/Izenda.AccountConstants';
import actions from 'modules/Account/Izenda.LoginActions';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Loading from 'share/components/controls/Izenda.Loading';
import Panel from 'share/components/controls/Izenda.Panel';
import Validator from 'share/components/hoc/Izenda.Validator';
import connect from 'share/enhancers/Izenda.Connect';
const ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
const CONSTRAINTS = AccountConstants.CONSTRAINTS;

const Header = ({ message }: { message: string }) => {
  return (
    <div>
      {!isNil(message) ? (
        <div className='izenda-Account-errorMessage u_textLeft'>
          <i className='icon-error-circled' />
          {message}
        </div>
      ) : null}
    </div>
  );
};

const Footer = ({
  localization,
  onClickSignIn,
  onClickForgotPassword
}: {
  localization: any,
  onClickForgotPassword: Function,
  onClickSignIn: Function
}) => {
  return (
    <div className='u_textCenter'>
      <button className='btn btn-primary u_fullWidth' onClick={onClickSignIn}>
        {localization.getText('ACOUNT_LABEL_SIGN_IN')}
      </button>
      <div className='u_textRight izenda-Account-ForgotPassword u_textUnderline'>
        <a onClick={onClickForgotPassword}>
          <span>{localization.getText('ACOUNT_LABEL_FORGOT_PASSWORD')}</span>
        </a>
      </div>
    </div>
  );
};

@connect(actions)
export default class Login extends Component {
  constructor(props: any) {
    super(props);

    if (!props.isLoggedIn(this)) {
      props.init(this);
    }
  }

  componentWillMount() {
    const props = this.props;

    if (!props.isLoggedIn(this)) {
      props.init(this);
    }
  }

  componentDidMount() {
    const props = this.props;
    props.loader && props.loader.endLoading();
    props.registerEventHandler(this);
  }

  componentWillUnmount() {
    this.props.unregisterEventHandler();
  }

  /**
   * Render organization.
   */
  renderOrganization() {
    const {
      localization,
      store: { model },
      onChangeTenantName
    } = this.props;

    return model.hasOrg ? (
      <GridLayout.Row>
        <GridLayout.Col cols='12'>
          <i className='icon-organization izenda-Account-Login-icon' />
          <ValidateInput
            type='text'
            className='form-control izenda-Account-Login-input'
            value={model.tenantName}
            onChange={onChangeTenantName}
            field='tenantName'
            placeholder={localization.getText('ACOUNT_LABEL_ORGANIZATION')}
            validations={CONSTRAINTS.tenantName}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    ) : null;
  }

  /**
   * Render body.
   */
  renderBody() {
    const {
      localization,
      store: { model },
      onChangeUserName,
      onChangePassword
    } = this.props;

    return (
      <GridLayout className='izenda-Account-Login-body'>
        {this.renderOrganization()}
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <i className='icon-useradmin izenda-Account-Login-icon' />
            <ValidateInput
              type='text'
              className='form-control izenda-Account-Login-input'
              value={model.userName}
              onChange={onChangeUserName}
              field='UserName'
              placeholder={localization.getText('ACOUNT_LABEL_USER_ID')}
              validations={CONSTRAINTS.userName}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <i className='icon-pass izenda-Account-Login-icon' />
            <ValidateInput
              autoComplete='on'
              type='password'
              className='form-control izenda-Account-Login-input'
              value={model.password}
              onChange={onChangePassword}
              field='Password'
              placeholder={localization.getText('COMMON_LABEL_PASSWORD')}
              validations={CONSTRAINTS.loginPassword}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  }

  render() {
    const { props } = this;
    const model = props.store.model;

    const header = {
      component: Header,
      message: model.message,
      className: 'izenda-Account-Login-header'
    };

    const footer = {
      component: Footer,
      onClickSignIn: props.onClickSignIn,
      className: 'izenda-Account-Login-footer',
      onClickForgotPassword: props.onClickForgotPassword,
      store: props.store,
      localization: props.localization
    };

    if (!model.enableForEnter) {
      return <Loading show />;
    }

    return (
      <div className='izenda-Account-Login u_inlineBlock'>
        <Panel
          className='izenda-Account-Container'
          header={header}
          footer={footer}
          panelBodyClassName='izenda-Account-Login-body'
        >
          {this.renderBody()}
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.Login.js